import React from 'react'; // Keep this import for JSX to be in scope

const LoadingIcon = () => (
  // Changed to implicit return as suggested by arrow-body-style
  <>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
      <circle
        fill="#999999"
        stroke="#999999"
        strokeWidth="9" // Fixed: Use camelCase for SVG attributes in JSX
        r="15"
        cx="40"
        cy="100"
      >
        <animate
          attributeName="opacity"
          calcMode="spline"
          dur="0.7"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.4"
        />{' '}
        {/* Fixed: Self-closing tag */}
      </circle>
      <circle
        fill="#999999"
        stroke="#999999"
        strokeWidth="9" // Fixed: Use camelCase for SVG attributes in JSX
        r="15"
        cx="100"
        cy="100"
      >
        <animate
          attributeName="opacity"
          calcMode="spline"
          dur="0.7"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.2"
        />{' '}
        {/* Fixed: Self-closing tag */}
      </circle>
      <circle
        fill="#999999"
        stroke="#999999"
        strokeWidth="9" // Fixed: Use camelCase for SVG attributes in JSX
        r="15"
        cx="160"
        cy="100"
      >
        <animate
          attributeName="opacity"
          calcMode="spline"
          dur="0.7"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="0"
        />{' '}
        {/* Fixed: Self-closing tag */}
      </circle>
    </svg>
  </>
);

export default LoadingIcon;
